/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { AgentSession, AgentSession$inboundSchema } from "./agentsession.js";

export type ListSessionsResponseBody = {
  items: Array<AgentSession>;
  nextCursor?: string | undefined;
};

/** @internal */
export const ListSessionsResponseBody$inboundSchema: z.ZodMiniType<
  ListSessionsResponseBody,
  unknown
> = z.pipe(
  z.object({
    items: z.array(AgentSession$inboundSchema),
    next_cursor: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "next_cursor": "nextCursor",
    });
  }),
);

export function listSessionsResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<ListSessionsResponseBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListSessionsResponseBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListSessionsResponseBody' from JSON`,
  );
}
